module.exports = new __parcel__URL__("snow-projections-median.63b0330f.jpg").toString();